import { render, staticRenderFns } from "./MAM_brandInfo.vue?vue&type=template&id=28eb050e&scoped=true&"
import script from "./MAM_brandInfo.vue?vue&type=script&lang=js&"
export * from "./MAM_brandInfo.vue?vue&type=script&lang=js&"
import style0 from "./MAM_brandInfo.vue?vue&type=style&index=0&id=28eb050e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb050e",
  null
  
)

export default component.exports